import React from 'react';

// Reusable "Why Choose Our Program" strip used across all program pages.
const WhyChooseSection = ({ id, title, bg = '#0C2212', iconColor = '#4ADE80', iconBg = 'rgba(34,197,94,0.12)', iconBorder = 'rgba(74,222,128,0.25)', items = [] }) => (
  <section id={id} style={{ padding: '36px 4%', background: bg }}>
    <style>{`
      .wcs-grid { display:grid; grid-template-columns:repeat(6,1fr); gap:1px; border-radius:12px; overflow:hidden; border:1px solid rgba(255,255,255,0.08); }
      .wcs-item { padding:22px 16px; background:rgba(255,255,255,0.03); display:flex; align-items:flex-start; gap:12px; }
      .wcs-item:not(:nth-child(6n+1)) { border-left:1px solid rgba(255,255,255,0.08); }
      @media(max-width:900px) {
        .wcs-grid { grid-template-columns:repeat(3,1fr); }
        .wcs-item:not(:nth-child(6n+1)) { border-left:none; }
        .wcs-item:not(:nth-child(3n+1)) { border-left:1px solid rgba(255,255,255,0.08); }
      }
      @media(max-width:480px) {
        .wcs-grid { grid-template-columns:repeat(2,1fr); }
        .wcs-item:not(:nth-child(3n+1)) { border-left:none; }
        .wcs-item:not(:nth-child(2n+1)) { border-left:1px solid rgba(255,255,255,0.08); }
      }
    `}</style>
    <div style={{ maxWidth: 1280, margin: '0 auto' }}>
      <h2 style={{ textAlign: 'center', fontSize: 18, fontWeight: 900, color: '#fff', letterSpacing: '0.06em', margin: '0 0 28px' }}>{title}</h2>
      <div className="wcs-grid">
        {items.map((w) => (
          <div key={w.title} className="wcs-item">
            <div style={{ width: 38, height: 38, borderRadius: 9, background: iconBg, border: `1px solid ${iconBorder}`, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <span style={{ color: iconColor, display: 'flex' }}>{w.icon}</span>
            </div>
            <div>
              <div style={{ fontSize: 13, fontWeight: 800, color: '#fff', marginBottom: 4, lineHeight: 1.3 }}>{w.title}</div>
              <div style={{ fontSize: 11.5, color: 'rgba(255,255,255,0.5)', lineHeight: 1.4 }}>{w.sub}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default WhyChooseSection;
